import React from "react";
import FeatureHeader from "../components/FeatureHeader";
import FloatingField from "../components/FloatingField";
import useFormPost from "../components/useFormPost";
import "../components/FormCard.css";
import "./Intake.css";

const supportOptions = [
  "Funds",
  "Pacifiers",
  "Clothes",
  "Diapering",
  "Feeding",
  "Other",
];

export default function Intake() {
  const { values: formData, status, handleChange, toggle, handleSubmit } = useFormPost("/api/intake", {
    name: "",
    email: "",
    address: "",
    babyWeight: "",
    needs: []
  });
  const submitting = status === "submitting";

  return (
    <div className="intake-page">
      <FeatureHeader badge="For NICU and PICU families" icon="heart" title="Request support">
        We’re here for the unexpected moments. Whether you need practical help
        with diapers, feeding essentials, or grocery and gas support, we want to
        make sure your family is supported during this season.
      </FeatureHeader>

      <section className="intake-section">
        <div className="container intake-layout">
          <form className="form-card" onSubmit={handleSubmit}>
            <FloatingField
              id="intake-name"
              label="Name"
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your full name"
              required
            />

            <FloatingField
              id="intake-email"
              label="Email (optional)"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="So we can reply to you"
              autoComplete="email"
            />

            <FloatingField
              id="intake-address"
              label="Address"
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Street address, city, state, ZIP"
              required
            />

            <FloatingField
              id="intake-babyWeight"
              label="Baby weight"
              type="text"
              name="babyWeight"
              value={formData.babyWeight}
              onChange={handleChange}
              placeholder="Example: 5 lb 8 oz"
              required
            />

            <fieldset>
              <legend>What are you looking for? (optional)</legend>
              <div className="checkbox-grid">
                {supportOptions.map((option) => (
                  <label key={option} className="check-option">
                    <input
                      type="checkbox"
                      checked={formData.needs.includes(option)}
                      onChange={() => toggle("needs", option)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </fieldset>

            <button type="submit" className="btn" disabled={submitting}>
              {submitting ? "Submitting…" : "Submit intake"}
            </button>

            {status === "sent" && (
              <p className="form-success">
                Thanks for reaching out. Your intake has been submitted and we’ll review it soon.
              </p>
            )}

            {status === "failed" && (
              <p className="form-error">
                Something went wrong and your intake didn’t send. Please try again, or
                email us at <a href="mailto:families@bugandfrog.org">families@bugandfrog.org</a>.
              </p>
            )}
          </form>
        </div>
      </section>
    </div>
  );
}
